import React, { useCallback, useEffect, useRef, useState } from "react";
import { Translate } from "react-localize-redux";

import { allGamesIcon, getCategoryIcon } from "../GameFilters/BettoGameFilters/categoryIcons";
import {
	BettoExploreFilterIcon,
	BettoExploreFilterPill,
	BettoExploreFilterScroll,
	BettoExploreFilterTrack,
	BettoExploreScrollButton,
	BettoExploreScrollFade,
} from "./elements";

export const BettoExploreFilters = ({ categories, selectedCategory, onCategorySelect }) => {
	const scrollRef = useRef(null);
	const [isScrollable, setIsScrollable] = useState(false);
	const [canScrollRight, setCanScrollRight] = useState(false);

	const updateScrollState = useCallback(() => {
		const el = scrollRef.current;
		if (!el) {
			setIsScrollable(false);
			setCanScrollRight(false);
			return;
		}

		const hasOverflow = el.scrollWidth > el.clientWidth + 2;
		setIsScrollable(hasOverflow);
		setCanScrollRight(hasOverflow && el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
	}, []);

	useEffect(() => {
		updateScrollState();
		const el = scrollRef.current;
		if (!el) return undefined;

		el.addEventListener("scroll", updateScrollState, { passive: true });
		window.addEventListener("resize", updateScrollState);

		return () => {
			el.removeEventListener("scroll", updateScrollState);
			window.removeEventListener("resize", updateScrollState);
		};
	}, [categories, updateScrollState]);

	const handleScrollRight = () => {
		scrollRef.current?.scrollBy({ left: 220, behavior: "smooth" });
	};

	return (
		<Translate>
			{({ translate }) => (
				<BettoExploreFilterTrack>
					<BettoExploreFilterScroll
						innerRef={scrollRef}
						$hasScrollPadding={isScrollable}>
						<BettoExploreFilterPill
							type="button"
							$active={!selectedCategory}
							data-active={!selectedCategory ? "true" : undefined}
							onClick={() => onCategorySelect(null)}>
							<BettoExploreFilterIcon
								src={allGamesIcon}
								alt=""
							/>
							<span>{translate("betto.casino.allGames")}</span>
						</BettoExploreFilterPill>

						{categories.map((category) => {
							const categoryIcon = getCategoryIcon(category.key);
							const isActive = selectedCategory === category.key;

							return (
								<BettoExploreFilterPill
									key={category.key}
									type="button"
									$active={isActive}
									data-active={isActive ? "true" : undefined}
									onClick={() => onCategorySelect(category.key)}>
									{categoryIcon && (
										<BettoExploreFilterIcon
											src={categoryIcon}
											alt=""
										/>
									)}
									<span>{category.value}</span>
								</BettoExploreFilterPill>
							);
						})}
					</BettoExploreFilterScroll>

					{isScrollable && <BettoExploreScrollFade aria-hidden />}
					{isScrollable && (
						<BettoExploreScrollButton
							type="button"
							aria-label="Scroll filters"
							disabled={!canScrollRight}
							onClick={handleScrollRight}
						/>
					)}
				</BettoExploreFilterTrack>
			)}
		</Translate>
	);
};
